import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import FlashContext from "components/FlashMessages/FlashContext";
import { MutationAccountUpdateDefaultWorkerPoolRunnerImagesArgs } from "types/generated";
import { createDefaultMutationHook } from "hooks/useMutationHandler";

import { UPDATE_DEFAULT_WORKER_POOL_RUNNER_IMAGES } from "./gql";

const useUpdateDefaultRunnerImagesMutation = createDefaultMutationHook(
  UPDATE_DEFAULT_WORKER_POOL_RUNNER_IMAGES
);

export const useUpdateDefaultRunnerImages = (refetchQueries?: string[]) => {
  const { reportSuccess } = useTypedContext(FlashContext);

  // const [updateRunnerImages] = useMutation(UPDATE_DEFAULT_WORKER_POOL_RUNNER_IMAGES, {
  //   refetchQueries: ,
  // });
  const [updateRunnerImages, { loading }] = useUpdateDefaultRunnerImagesMutation({
    refetchQueries,
    awaitRefetchQueries: true,
  });

  const onUpdate = useCallback(
    (input: MutationAccountUpdateDefaultWorkerPoolRunnerImagesArgs) => {
      updateRunnerImages(
        {
          publicWorkerPoolRunnerImage: input.publicWorkerPoolRunnerImage,
          privateWorkerPoolRunnerImage: input.privateWorkerPoolRunnerImage,
        },
        (data) => {
          if (data) {
            reportSuccess({
              message: `Default runner images have been updated`,
            });
          }
        }
      );
    },
    [updateRunnerImages, reportSuccess]
  );

  return { onUpdate, loading };
};
